import React from 'react'

export const Music = (props) => {
  return (
      <iframe title='spotify' className="w-full h-20 sm:h-60" src={props.targetUrl} frameBorder="0" allowFullScreen allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
  )
}
